import { Translations } from "../plugins/translations";
import Roles from "@/enums/Roles.js";

import LoginLayout from "@/layouts/LoginLayout.vue";
import AppLayout from "@/layouts/AppLayout.vue";
import Login from "@/views/login/index.vue";

const routes = [
  {
    path: "/",
    component: AppLayout,
    meta: {
      requiresAuth: true,
      permission: "*",
    },
    children: [
      {
        path: "/",
        component: () => import("../views/dashboard/index.vue"),
        name: "Dashboard",
        meta: {
          requiresAuth: true,
          permission: "*",
        },
      },
      {
        path: "/users",
        component: () => import("../views/users/index.vue"),
        name: "Users",
        meta: {
          requiresAuth: true,
          permission: `${Roles.ADMIN}`,
        },
      },
      {
        path: "/users/:id/permissions",
        component: () => import("../views/users/UserPermissions.vue"),
        name: "UserPermissions",
        meta: {
          requiresAuth: true,
          permission: `${Roles.ADMIN}`,
        },
      },
      {
        path: "/projects",
        component: () => import("../views/projects/index.vue"),
        name: "Projects",
        meta: {
          requiresAuth: true,
          permission: `${Roles.ADMIN}`,
        },
      },
      {
        path: "/project/:id/logs",
        component: () => import("../views/projects/Logs.vue"),
        name: "ProjectLogs",
        meta: {
          requiresAuth: true,
          permission: `${Roles.ADMIN}`,
        },
      },
      {
        path: "/project/:id/apis",
        component: () => import("../views/projects/apis/index.vue"),
        name: "ProjectApis",
        meta: {
          requiresAuth: true,
          permission: `${Roles.ADMIN}`,
        },
      },
      {
        path: "/project/:projectId/apis/:apiId/logs",
        component: () => import("../views/projects/apis/Logs.vue"),
        name: "ProjectApisLogs",
        meta: {
          requiresAuth: true,
          permission: `${Roles.ADMIN}`,
        },
      },
      {
        path: "/logs",
        component: () => import("../views/logs/index.vue"),
        name: "Logs",
        meta: {
          requiresAuth: true,
          permission: `${Roles.ADMIN}`,
        },
      },
      {
        path: "/request-logs",
        component: () => import("../views/request-logs/index.vue"),
        name: "RequestLogs",
        meta: {
          requiresAuth: true,
          permission: `${Roles.ADMIN}`,
        },
      },
      {
        path: "/tokens",
        component: () => import("../views/tokens/index.vue"),
        name: "Tokens",
        meta: {
          requiresAuth: true,
          permission: `${Roles.CLIENT}`,
        },
      },
      {
        path: "/apis",
        component: () => import("../views/apis/index.vue"),
        name: "Apis",
        meta: {
          requiresAuth: true,
          permission: `${Roles.CLIENT}`,
        },
      },
    ],
  },
  {
    path: "",
    component: LoginLayout,
    meta: {
      requiresAuth: false,
      permission: null,
    },
    beforeEnter: Translations.routeMiddleware,
    children: [
      {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
          requiresAuth: false,
          permission: "*",
        },
      },
    ],
  },
];

export default routes;
